import React, { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";

// @mui/material components
import { Dialog, DialogTitle, DialogContent, CircularProgress } from "@mui/material";

// core components
import EditForm from './editForm';

// api
import get from "api/brand/get";

// The brands collection is light, so we fetch the full brand (translations, ctaLinks, content) here
// before rendering the form.
function EditDialog(props) {
    const { brand, closeDialog, isOpen, onExited, onUpdated } = props;

    const [fullBrand, setFullBrand] = useState(null);
    const [retrieveFailed, setRetrieveFailed] = useState(false);

    useEffect(() => {
        get(brand["@id"])
            .then((retrieved) => setFullBrand(retrieved))
            .catch(() => setRetrieveFailed(true));
    }, []);

    const renderContent = () => {
        if (retrieveFailed) {
            return <FormattedMessage id={"list.error"} />;
        }

        if (fullBrand === null) {
            return <CircularProgress />;
        }

        return (
            <EditForm
                closeDialog={closeDialog}
                brand={fullBrand}
                onUpdated={onUpdated}
            />
        );
    };

    return (
        <Dialog
            open={isOpen}
            onClose={closeDialog}
            maxWidth={'sm'}
            scroll={'body'}
            // CKEditor balloons (link URL input) are rendered outside the dialog, the focus trap would steal their focus
            disableEnforceFocus
            TransitionProps={{ onExited: onExited }}
        >
            <DialogTitle>
                <FormattedMessage id={"brand.form.update.title"} />
            </DialogTitle>
            <DialogContent>
                {renderContent()}
            </DialogContent>
        </Dialog>
    )
}

export default EditDialog;
